
var React =         require("react");

class Viewer3D extends React.Component {

    constructor() {
        super();

        this.containerRef = this.containerRef.bind(this);
        this.onSceneLoaded = this.onSceneLoaded.bind(this);
        this.loadLibraryIOModel = this.loadLibraryIOModel.bind(this);
    }

    containerRef(item) {
        this.container = item;
    }

    componentDidMount() {
        var viewerApp = new ViewerApplication(this.container);
        viewerApp.handler = this;
        viewerApp.needGroundplane = false;
        viewerApp.initialize();
        this.viewerApp = viewerApp;
        this.setUpForLibraryIO(0xE8E8E8);
        this.loadLibraryIOModel(this.props.objPath, this.props.mtlPath);
    }

    setUpForLibraryIO (backgroundColor) {
        var editor3d = this.viewerApp.editor3d;
        $("div.viewcube__button").hide();
    
        var light = new THREE.AmbientLight(0xd0d0d0);
        editor3d.getView().scene.add(light);
        var distance = 400;
    
        var spotLight = new THREE.SpotLight( 0x202020 );
        spotLight.position.set( distance, distance, distance );
        editor3d.getView().scene.add(spotLight);
    
        var spotLight = new THREE.SpotLight( 0x202020 );
        spotLight.position.set( -distance, distance, distance );
        editor3d.getView().scene.add(spotLight);
    
        var spotLight = new THREE.SpotLight( 0x202020 );
        spotLight.position.set( -distance, -distance, distance );
        editor3d.getView().scene.add(spotLight);
    
        var spotLight = new THREE.SpotLight( 0x202020 );
        spotLight.position.set( distance, -distance, distance );
        editor3d.getView().scene.add(spotLight);
    
        var light = new THREE.HemisphereLight(0xa0a0a0, 0x000000, 0.75);
        editor3d.getView().scene.add(light);
    
        if(backgroundColor != undefined) {
            editor3d.getView().scene.background = new THREE.Color(backgroundColor);
        }
    };
    
    /**
     * 
     * @param {*} item https://contapi.circuits.io/123D-Circuits/3dmodels/2542889/
     */
    loadLibraryIOModel(objPath, mtlPath) {
        // Load content for 
        var viewerApp = this.viewerApp;
        var editor3d = viewerApp.editor3d;
        var self = this;
        viewerApp.clearScene();
        var mtlLoader = new THREE.MTLLoader();
    
        var onProgress = function (xhr) {
            if (xhr.lengthComputable) {
                var percentComplete = xhr.loaded / xhr.total * 100;
                console.log(Math.round(percentComplete, 2) + '% downloaded');
            }
        };
    
        var onError = function (xhr) {
            self.props.setError({statusText:"This usually happens because the model has no geometry to convert.  It can still be used in Fusion.", message:""}, null, "The OBJ translation has failed.  We cannot render this model on the web.");
            self.onSceneLoaded("Error Loading the scene.");
        };
    
        var modfiyMaterials = function (materials) {
            for (var key in materials) {
                var material = materials[key];
                material.shading = THREE.FlatShading;
                material.specular = new THREE.Color(0x808080);
                material.shininess = 25;
            }
        }
        
    
        mtlLoader.load(mtlPath, function (materials) {
            materials.preload();
    
            modfiyMaterials(materials.materials);
            
            loadObject(materials);
        }, undefined, (error)=>{
            // if mtl load fails, still load, just give a default material
            loadObject();
        });
        
        
        function loadObject(materials){
          var objLoader = new THREE.OBJLoader();
          
          if(materials){
            objLoader.setMaterials(materials);
          }

          objLoader.load(objPath, function (object) {
              if(!materials){
                // apply default material
                for (let i = 0; i < object.children.length; i++) {
                    object.children[i].material = new THREE.MeshPhongMaterial({
                      color: 0x8a8a8a, 
                      specular: new THREE.Color(0x808080),
                      shininess: 25
                    })
                }
              }
              // handle bounding box
              var bounds = new THREE.Box3();
              for (var i = 0; object && i < object.children.length; i++) {
                  var item = object.children[i].geometry;
                  item.computeBoundingBox()
                  bounds.union(item.boundingBox);
              }

              var w = (bounds.max.x - bounds.min.x)
              var d = (bounds.max.y - bounds.min.y)
              var h = (bounds.max.z - bounds.min.z)
              var halfMax = Math.max(w, h, d) / 2.2;

              // center the object
              var center = bounds.getCenter();
              var matrix = new THREE.Matrix4().makeTranslation(-center.x, -center.y, -center.z);
              object.applyMatrix(matrix);

              self.onSceneLoaded();

              editor3d.getView().scene.add(object);
              viewerApp.navigatingMode.autocam.distanceLimit = halfMax;
              viewerApp.navigatingMode.autocam.dollyByDelta(-4);
              viewerApp.navigatingMode.autocam.dollyByDelta(-halfMax);
             
              viewerApp.clearScene = function () {
                  while (object && object.children.length > 0) {
                      var item = object.children.pop();
                      if (item && item.geometry) {
                          item.geometry.dispose();
                      }
                  }

                  editor3d.getView().scene.remove(object);
                  editor3d.getView().invalidate();
              };
          }, onProgress, onError);
        }
  
    }

    componentWillUnmount() {
        this.viewerApp.destroy();
        this.destroyed = true;
    }

    onSceneLoaded(error) {
        if(this.props.onLoad) {
            this.props.onLoad(error);
        } 
        if(this.destroyed || error) {
            return ;
        }
        this.container.style="display: block; height: 100%;"; 
        window.dispatchEvent(new Event('resize'))
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
        <div ref={this.containerRef} className="viewer" style={{"display": "none"}}>

        </div>);
    }
}

module.exports = Viewer3D;
